import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// The ONLY access rule in the frontend: user.permissions (from /auth/me, built from backend/permissions.py).
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F5F1]">
        <div className="h-10 w-10 rounded-full border-4 border-[#45423C]/20 border-t-[#45423C] animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  const screen = pathname.startsWith("/menu") ? "/menu" : pathname;
  const lvl = user.permissions?.[screen] ?? "-";
  if (screen === "/menu" && lvl === "O") return <Navigate to="/" replace />;
  if (user.role === "supplier" && lvl === "-") return <Navigate to="/portal" replace />;
  if (lvl === "-") return <Navigate to={pathname === "/" ? "/login" : "/"} replace />;
  return children;
}
